export default __webpack_public_path__ + "static/media/founders-vegshelf.7581d2a9.png";